/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DeadwoodRipLayers, Layers} from "../../../view/DeadwoodRipLayers";
import {gsap, TimelineLite} from "gsap";
import {DeadwoodRip} from "../../../DeadwoodRip";

export class BigWinView {

    private _layer:StageLayer;
    private _spine:PIXI.spine.Spine;
    private _effectSpine:PIXI.spine.Spine | null;

    constructor() {
        this._layer = DeadwoodRipLayers.getLayer(Layers.BIG_WIN)!;
    }

    public getLevelAnimation(level:number, duration:number, isEndLevel:boolean):TimelineLite {
        let oldSpine:PIXI.spine.Spine;
        if(this._spine) {
            oldSpine = this._spine;
        }
        if(!this._effectSpine) {
            this._effectSpine = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset('bwEffect'));
            this._effectSpine.autoUpdate = true;
            this._effectSpine.position.set(360, 360);
        }
        this._spine = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset(`bw${level + 1}`));
        this._spine.autoUpdate = true;
        this._spine.position.set(360, 360);
        const tl = new TimelineLite();
        tl.add([
            DeadwoodRip.background.dimScreen(0.65, 0.4, this._layer),
            () => {
                this._layer.addChild(this._spine);
                this._spine.state.setAnimation(0, `Level${level + 1}`, false);
                this._layer.addChild(this._effectSpine!);
                this._effectSpine!.state.setAnimation(0, `effect`, false);
                this.removeOldSpine(oldSpine);
            }
        ]);
        return tl;
    }

    public playEnding(endLevel:number):void {
        const entry = this._spine.state.getCurrent(0);
        if(entry) {
            entry.trackTime = entry.animationEnd;
        }
        const tl = new TimelineLite();
        tl.add(DeadwoodRip.background.dimScreen(0, 0.4));
        tl.add(gsap.to(this._spine, 0.2, {alpha : 0}), 0.4);
        tl.add(() => {
            this.removeOldSpine(this._spine);
            this.removeOldSpine(this._effectSpine!);
            this._effectSpine = null;
        });
    }

    private removeOldSpine(oldSpine:PIXI.spine.Spine):void {
        if(oldSpine) {
            if(oldSpine.parent) {
                oldSpine.state.setEmptyAnimations(0);
                oldSpine.parent.removeChild(oldSpine);
                oldSpine.destroy();
            }
        }
    }
}